import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import { DeleteDialogUI, FileUploadDialogUI } from '../Interface';
import dynamicFormService from '../../service/dynamicForm.service';

const DynamicFormCreatorTemplate = (props) => {
  const { selectedValuesState, refetchState } = props;
  const { selectedValues } = selectedValuesState;
  const { setRefetchTable } = refetchState;
  const [uploadDialog, setUploadDialog] = useState(false);
  const [deleteDialog, setDeletDialog] = useState(false);

  const handleEdit = () => {
    setUploadDialog(true);
  };

  const handleCloseUploadDialog = () => {
    setUploadDialog(false);
  };

  const handleUpload = (files) => {
    dynamicFormService.uploadFile(selectedValues.id, files).then(() => {
      setRefetchTable(true);
      addNotification({
        content: 'Fájl sikeresen feltöltve!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleDelete = () => {
    setDeletDialog(true);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    dynamicFormService.deleteFile().then((data) => {
      hideDeleteDialog();
    });
  };

  const handleDownload = async () => {
    //await formPrintTemplateService.getFile(template.id, template.name);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sablon</TableCell>
              <TableCell align="center">Műveletek</TableCell>
            </TableRow>
          </TableHead>
          {selectedValues.id && (
            <TableBody>
              <TableRow key={selectedValues.id}>
                <TableCell>{selectedValues.filename ?? 'Nincs hozzáadott sablon'}</TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleEdit()} aria-label="edit">
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete()} aria-label="delete">
                    <DeleteIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDownload()} aria-label="download">
                    <DownloadIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <FileUploadDialogUI
        open={uploadDialog}
        handleClose={handleCloseUploadDialog}
        handleUpload={(files) => {
          handleUpload(files);
          handleCloseUploadDialog();
        }}
        single
      />
      <DeleteDialogUI handleRemoveElement={handleRemoveElement} show={deleteDialog} onHide={() => hideDeleteDialog()} />
    </>
  );
};

export default DynamicFormCreatorTemplate;
